import type { Notification } from "@bracket/ui";



export const exception = ( error: Error,): Omit<Notification, "id"> => {
	console.warn("an exception occured in the vault store", error);
	return {
		type: "error",
		title: "Failed to complete transaction",
		message: "Opps! something went wrong, please try again later.",
		status: "error",
		primaryAction: {
			label: "Dismiss",
			onClick: () => {
			},
		},
	};
};

